// import { useState, useEffect, useCallback } from "react";
// import { collection, getDocs } from "firebase/firestore";
// import { db } from "../../firebase";
// import { deleteDoc, doc } from "firebase/firestore";

// export const useCartCalculations = ({
//   cartProducts,
//   discountInHok,
//   currentUser,
// }) => {
//   const [totalPrice, setTotalPrice] = useState(0);
//   const [newFinValue, setNewFinValue] = useState(0);
//   const [visibleDiscount, setVisibleDiscount] = useState(0);
//   const [promoCode, setPromoCode] = useState("");

//   useEffect(() => {
//     if (!cartProducts) return;

//     const calculate = async () => {
//       // Загальна сума всіх товарів (з їх власними акціями)
//       let total = 0;
//       let nonDiscountedPart = 0;

//       cartProducts.forEach((item) => {
//         const isAction = !!item.actionDiscountPercent;
//         const basePrice = isAction
//           ? Math.round(
//               item.price - (item.price * item.actionDiscountPercent) / 100
//             )
//           : item.price;

//         total += basePrice * item.quantity;

//         if (!isAction) {
//           nonDiscountedPart += basePrice * item.quantity;
//         }
//       });

//       setTotalPrice(total);

//       let finalValue = total;

//       // Профільна знижка застосовується тільки до неакційних товарів
//       if (discountInHok > 0 && nonDiscountedPart > 0) {
//         const profileDiscount = (nonDiscountedPart * discountInHok) / 100;
//         finalValue -= profileDiscount;
//       }

//       // Перевірка знижки cartdiscount тільки на неакційні товари
//       const snapshot = await getDocs(collection(db, "cartdiscount"));
//       const now = new Date();
//       const discounts = snapshot.docs
//         .map((doc) => ({ id: doc.id, ...doc.data() }))
//         .filter((d) => {
//           const start = d.startDate ? new Date(d.startDate) : null;
//           const end = new Date(d.endDate);
//           return (
//             (!start || now >= start) &&
//             now <= end &&
//             nonDiscountedPart >= d.amount
//           );
//         })
//         .sort((a, b) => b.amount - a.amount);

//       let cartDiscountPercent = 0;
//       if (discounts.length) {
//         cartDiscountPercent = discounts[0].percent;
//       }

//       if (cartDiscountPercent > 0 && nonDiscountedPart > 0) {
//         const cartDiscValue = (nonDiscountedPart * cartDiscountPercent) / 100;
//         finalValue -= cartDiscValue;
//       }

//       setNewFinValue(Math.round(finalValue));
//       setVisibleDiscount(cartDiscountPercent);
//     };

//     calculate();
//   }, [cartProducts, discountInHok]);

//   const applyPromoCode = useCallback(
//     async (promoData, currentCart) => {
//       if (!promoData || promoData.code !== promoCode) return false;

//       if (!currentCart || currentCart.length === 0) {
//         return false;
//       }

//       const appliesTo = promoData.appliesTo || {};
//       const appliesToProducts = appliesTo.products || [];
//       const appliesToAuthors = appliesTo.authors || [];
//       const appliesToSeries = appliesTo.series || [];

//       const isUniversal =
//         appliesToProducts.length === 0 &&
//         appliesToAuthors.length === 0 &&
//         appliesToSeries.length === 0;

//       let nonDiscountedPart = 0;

//       currentCart.forEach((item) => {
//         const isAction = !!item.actionDiscountPercent;
//         if (isAction) {
//           return;
//         }

//         let match = false;

//         if (isUniversal) {
//           match = true;
//         } else {
//           const matchProduct = appliesToProducts.includes(item.id);

//           // const itemAuthors = Array.isArray(item.textAutor)
//           //   ? item.textAutor
//           //   : typeof item.textAutor === "string"
//           //   ? [item.textAutor]
//           //   : [];

//           // const matchAuthor = itemAuthors.some((a) =>
//           //   appliesToAuthors.includes(a)
//           // );

//           const itemAuthors = Array.isArray(item.textAutor)
//             ? item.textAutor.map((a) => a.split(" ")[0].toLowerCase())
//             : typeof item.textAutor === "string"
//             ? [item.textAutor.split(" ")[0].toLowerCase()]
//             : [];

//           const matchAuthor = itemAuthors.some((a) =>
//             appliesToAuthors
//               .map((x) => x.split(" ")[0].toLowerCase())
//               .includes(a)
//           );
//           const itemSeries = Array.isArray(item.seria)
//             ? item.seria
//             : typeof item.seria === "string"
//             ? [item.seria]
//             : [];

//           const matchSeries = itemSeries.some((s) =>
//             appliesToSeries.includes(s)
//           );

//           match = matchProduct || matchAuthor || matchSeries;
//         }

//         if (match) {
//           const subtotal = item.price * item.quantity;
//           nonDiscountedPart += subtotal;
//         } else {
//         }
//       });

//       if (nonDiscountedPart <= 0) {
//         return false;
//       }

//       const promoDiscount = (nonDiscountedPart * promoData.discount) / 100;
//       const nonPromoPart = totalPrice - nonDiscountedPart;
//       const newFinal = nonPromoPart + (nonDiscountedPart - promoDiscount);

//       setNewFinValue(Math.round(newFinal));

//       if (promoData.isSingleUse) {
//         await deleteDoc(doc(db, "promo", promoData.id));
//       }

//       return true;
//     },
//     [promoCode, totalPrice] // ❗️ тут уже НЕ треба cartProducts
//   );

//   const applyElefant = async (updateUserElefant) => {
//     if (!currentUser || parseInt(currentUser.elefant) === 0) return false;
//     const elephants = parseInt(currentUser.elefant);
//     const updatedValue = Math.max(newFinValue - elephants, 0);
//     setNewFinValue(Math.round(updatedValue));
//     await updateUserElefant(currentUser.uid);
//     return elephants;
//   };

//   return {
//     totalPrice,
//     newFinValue,
//     visibleDiscount,
//     promoCode,
//     setPromoCode,
//     applyPromoCode,
//     applyElefant,
//   };
// };
import { useState, useEffect, useCallback } from "react";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { db } from "../../firebase";

export const useCartCalculations = ({
  cartProducts,
  discountInHok,
  currentUser,
}) => {
  const [totalPrice, setTotalPrice] = useState(0);
  const [newFinValue, setNewFinValue] = useState(0);
  const [visibleDiscount, setVisibleDiscount] = useState(0);
  const [promoCode, setPromoCode] = useState("");

  // ефективна (базова для підсумків) ціна одиниці товару
  const effectiveItemPrice = (item) => {
    const hasPriceSale =
      item.priceSale !== undefined &&
      item.priceSale !== null &&
      item.priceSale !== "";
    const isSale = !!item.saleDiscountPercent;
    const isAction = !!item.actionDiscountPercent;

    if (hasPriceSale) return Number(item.priceSale);
    if (isSale)
      return Math.round(
        item.price - (item.price * Number(item.saleDiscountPercent)) / 100
      );
    if (isAction)
      return Math.round(
        item.price - (item.price * Number(item.actionDiscountPercent)) / 100
      );
    return Number(item.price);
  };

  useEffect(() => {
    if (!cartProducts) return;

    const calculate = async () => {
      let total = 0;
      let nonDiscountedPart = 0; // частина, на яку можна накладати профільну/cartdiscount

      cartProducts.forEach((item) => {
        const isSale = !!item.saleDiscountPercent; // ⬅️ розпродаж
        const isAction = !!item.actionDiscountPercent;

        const basePrice = effectiveItemPrice(item);
        total += basePrice * item.quantity;

        // ❗️Промо/профільна/cartdiscount НЕ застосовуються до розпродажу і акцій
        if (!isSale && !isAction) {
          nonDiscountedPart += basePrice * item.quantity;
        }
      });

      setTotalPrice(Math.round(total));

      let finalValue = total;

      // профільна знижка (лише до nonDiscountedPart)
      if (discountInHok > 0 && nonDiscountedPart > 0) {
        const profileDiscount = (nonDiscountedPart * discountInHok) / 100;
        finalValue -= profileDiscount;
      }

      // cartdiscount (також лише до nonDiscountedPart)
      const snapshot = await getDocs(collection(db, "cartdiscount"));
      const now = new Date();
      const discounts = snapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((d) => {
          const start = d.startDate ? new Date(d.startDate) : null;
          const end = d.endDate ? new Date(d.endDate) : null;
          return (
            (!start || now >= start) &&
            (!end || now <= end) &&
            nonDiscountedPart >= d.amount
          );
        })
        .sort((a, b) => b.amount - a.amount);

      let cartDiscountPercent = 0;
      if (discounts.length) {
        cartDiscountPercent = discounts[0].percent;
      }

      if (cartDiscountPercent > 0 && nonDiscountedPart > 0) {
        const cartDiscValue = (nonDiscountedPart * cartDiscountPercent) / 100;
        finalValue -= cartDiscValue;
      }

      setNewFinValue(Math.round(finalValue));
      setVisibleDiscount(cartDiscountPercent);
    };

    calculate();
  }, [cartProducts, discountInHok]);

  const applyPromoCode = useCallback(
    async (promoData, currentCart) => {
      if (!promoData || promoData.code !== promoCode) return false;
      if (!currentCart || currentCart.length === 0) return false;

      const appliesTo = promoData.appliesTo || {};
      const appliesToProducts = appliesTo.products || [];
      const appliesToAuthors = appliesTo.authors || [];
      const appliesToSeries = appliesTo.series || [];

      const isUniversal =
        appliesToProducts.length === 0 &&
        appliesToAuthors.length === 0 &&
        appliesToSeries.length === 0;

      let nonDiscountedPart = 0;

      currentCart.forEach((item) => {
        const isSale = !!item.saleDiscountPercent; // ❗️не беремо у промо
        const isAction = !!item.actionDiscountPercent; // як і раніше — теж ні
        if (isSale || isAction) return;

        // чи підпадає за таргетом промо
        let match = false;

        if (isUniversal) {
          match = true;
        } else {
          const matchProduct = appliesToProducts.includes(item.id);

          const itemAuthors = Array.isArray(item.textAutor)
            ? item.textAutor.map((a) => a.split(" ")[0].toLowerCase())
            : typeof item.textAutor === "string"
            ? [item.textAutor.split(" ")[0].toLowerCase()]
            : [];

          const matchAuthor = itemAuthors.some((a) =>
            appliesToAuthors
              .map((x) => x.split(" ")[0].toLowerCase())
              .includes(a)
          );

          const itemSeries = Array.isArray(item.seria)
            ? item.seria
            : typeof item.seria === "string"
            ? [item.seria]
            : [];

          const matchSeries = itemSeries.some((s) =>
            appliesToSeries.includes(s)
          );

          match = matchProduct || matchAuthor || matchSeries;
        }

        if (match) {
          const eff = effectiveItemPrice(item); // консистентно з total
          nonDiscountedPart += eff * item.quantity;
        }
      });

      if (nonDiscountedPart <= 0) return false;

      const promoDiscount = (nonDiscountedPart * promoData.discount) / 100;

      // нова сума: (все інше) + (eligible частина з промо-знижкою)
      const nonPromoPart = totalPrice - nonDiscountedPart;
      const newFinal = nonPromoPart + (nonDiscountedPart - promoDiscount);

      setNewFinValue(Math.round(newFinal));

      if (promoData.isSingleUse) {
        await deleteDoc(doc(db, "promo", promoData.id));
      }

      return true;
    },
    [promoCode, totalPrice]
  );

  const applyElefant = async (updateUserElefant) => {
    if (!currentUser || parseInt(currentUser.elefant) === 0) return false;
    const elephants = parseInt(currentUser.elefant);
    const updatedValue = Math.max(newFinValue - elephants, 0);
    setNewFinValue(Math.round(updatedValue));
    await updateUserElefant(currentUser.uid);
    return elephants;
  };

  return {
    totalPrice,
    newFinValue,
    visibleDiscount,
    promoCode,
    setPromoCode,
    applyPromoCode,
    applyElefant,
  };
};
